<template>
  <div
    class="bg-white rounded-md px-3 py-2 cursor-pointer shadow"
  >
    <span
      v-if="survey.emoji"
      class="mr-2"
    >{{ survey.emoji }}</span> <span>{{ survey.theme ?? survey.name }}</span>
  </div>
</template>

<script lang="ts" setup>
import {Survey} from "@/core/interfaces/survey/Survey";

defineProps<{
    survey: Survey;
}>();
</script>

<style scoped>
.survey-card-container:hover img {
    transition: ease 0.8s;
    transform: scale(1.1);
}
</style>
